import { render, staticRenderFns } from "./ChemUPEI2210A6Q5.vue?vue&type=template&id=280349d6&"
import script from "./ChemUPEI2210A6Q5.vue?vue&type=script&lang=js&"
export * from "./ChemUPEI2210A6Q5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
